(function() {
    'use strict';
    
    /**
     * Service pour récupérer les données du Budget de l'État et du TOFE
     * depuis l'API REST au lieu des données mockées
     */
    angular
        .module('observatoireApp')
        .factory('BudgetApiService', BudgetApiService);

    BudgetApiService.$inject = ['$http', '$q'];
        
    function BudgetApiService($http, $q) {
        // Cache pour les données de référence
        var cache = {
            jeuxDonnees: [],
            typesDonnees: {}
        };
        
        // Fonction utilitaire pour normaliser les identifiants en chaînes
    function normalizeId(id) {
        return id !== null && id !== undefined ? String(id) : id;
    }
    
    // Fonction utilitaire pour extraire le contenu des réponses paginées
    function extractContent(response) {
        if (response && response.data && response.data.content) {
            console.log('[BudgetApiService] Extraction du contenu paginé:', response.data.content);
            return { data: response.data.content };
        }
        return response;
    }
    
    // Fonction utilitaire pour générer des données mockées
        function generateMockData(jeuDonneesCode, typeCode, annee) {
            console.log('[BudgetApiService] Génération de données mockées pour:', jeuDonneesCode, typeCode, annee);
            
            var data = {
                libelle: 'Total',
                montant: 0,
                pourcentage: 100,
                enfants: []
            };
            
            // Données spécifiques selon le type
            if (jeuDonneesCode === 'budget-etat') {
                if (typeCode === 'recettes-fiscales') {
                    data.montant = 1500000000;
                    data.enfants = [
                        { libelle: 'Recettes fiscales', montant: 800000000, pourcentage: 53 },
                        { libelle: 'Dons et legs', montant: 250000000, pourcentage: 17 },
                        { libelle: 'Autres recettes', montant: 450000000, pourcentage: 30 }
                    ];
                } else { // depenses-investissement ou autre
                    data.montant = 2500000000;
                    data.enfants = [
                        { libelle: 'Dépenses de personnel', montant: 750000000, pourcentage: 30 },
                        { libelle: 'Dépenses de biens et services', montant: 625000000, pourcentage: 25 },
                        { libelle: 'Dépenses de transfert', montant: 500000000, pourcentage: 20 },
                        { libelle: 'Dépenses d\'investissement', montant: 625000000, pourcentage: 25 }
                    ];
                }
            } else if (jeuDonneesCode === 'tableau-des-operations-financieres-de-letat') {
                if (typeCode === 'recettes-dons') {
                    data.montant = 1800000000;
                    data.enfants = [
                        { libelle: 'Recettes fiscales', montant: 900000000, pourcentage: 50 },
                        { libelle: 'Recettes non fiscales', montant: 360000000, pourcentage: 20 },
                        { libelle: 'Dons', montant: 540000000, pourcentage: 30 }
                    ];
                } else if (typeCode === 'depenses') {
                    data.montant = 2400000000;
                    data.enfants = [
                        { libelle: 'Courantes', montant: 1440000000, pourcentage: 60 },
                        { libelle: 'Investissement', montant: 960000000, pourcentage: 40 }
                    ];
                } else { // financement ou autre
                    data.montant = 600000000;
                    data.enfants = [
                        { libelle: 'Financement extérieur (net)', montant: 360000000, pourcentage: 60 },
                        { libelle: 'Financement bancaire (net)', montant: 120000000, pourcentage: 20 },
                        { libelle: 'Autres financements (net)', montant: 120000000, pourcentage: 20 }
                    ];
                }
            } else {
                // Données génériques
                data.montant = 1000000000;
                data.enfants = [
                    { libelle: 'Catégorie A', montant: 400000000, pourcentage: 40 },
                    { libelle: 'Catégorie B', montant: 300000000, pourcentage: 30 },
                    { libelle: 'Catégorie C', montant: 200000000, pourcentage: 20 },
                    { libelle: 'Catégorie D', montant: 100000000, pourcentage: 10 }
                ];
            }
            
            return data;
        }
        
        // Méthodes exposées par le service
        return {
            // Récupérer tous les jeux de données disponibles
            getJeuxDonnees: function() {
                console.log('[BudgetApiService] Appel getJeuxDonnees');
                
                // Si les données sont en cache, on les renvoie directement
                if (cache.jeuxDonnees.length > 0) {
                    console.log('[BudgetApiService] Utilisation du cache pour getJeuxDonnees:', cache.jeuxDonnees);
                    var deferred = $q.defer();
                    deferred.resolve({ data: cache.jeuxDonnees });
                    return deferred.promise;
                }
                
                // Sinon, on les récupère depuis l'API et on les met en cache
                console.log('[BudgetApiService] Requête GET vers /api/budget/jeux-donnees');
                return $http.get('/api/budget/jeux-donnees')
                    .then(function(response) {
                        console.log('[BudgetApiService] Réponse reçue de /api/budget/jeux-donnees:', response);
                        // Vérifier si la réponse contient un attribut content (pagination Spring)
                        var responseData = extractContent(response).data;
                        
                        // Normaliser les identifiants en chaînes
                        var normalizedData = responseData.map(function(item) {
                            return {
                                id: normalizeId(item.id),
                                code: item.code,
                                libelle: item.libelle
                            };
                        });
                        
                        console.log('[BudgetApiService] Données normalisées:', normalizedData);
                        cache.jeuxDonnees = normalizedData;
                        return { data: normalizedData };
                    })
                    .catch(function(error) {
                        console.error('[BudgetApiService] Erreur lors de la récupération des jeux de données:', error);
                        // Créer des données de secours pour permettre à l'interface de fonctionner
                        var mockData = [
                            { id: 1, code: 'budget-etat', libelle: 'Budget de l\'État' },
                            { id: 2, code: 'tableau-des-operations-financieres-de-letat', libelle: 'Tableau des opérations financières de l\'État' }
                        ];
                        cache.jeuxDonnees = mockData;
                        return { data: mockData };
                    });
            },
            
            // Récupérer tous les types de données pour un jeu de données
            getTypesDonnees: function(jeuDonneesCode) {
                console.log('[BudgetApiService] Appel getTypesDonnees pour jeuDonneesCode:', jeuDonneesCode);
                
                // Normaliser l'identifiant du jeu de données
                jeuDonneesCode = normalizeId(jeuDonneesCode);
                
                // Si les données sont en cache, on les renvoie directement
                if (cache.typesDonnees[jeuDonneesCode]) {
                    console.log('[BudgetApiService] Utilisation du cache pour getTypesDonnees:', cache.typesDonnees[jeuDonneesCode]);
                    var deferred = $q.defer();
                    deferred.resolve({ data: cache.typesDonnees[jeuDonneesCode] });
                    return deferred.promise;
                }
                
                // Sinon, on les récupère depuis l'API et on les met en cache
                var apiUrl = '/api/budget/jeux-donnees/' + jeuDonneesCode + '/types';
                console.log('[BudgetApiService] Requête GET vers ' + apiUrl);
                
                return $http.get(apiUrl)
                    .then(function(response) {
                        console.log('[BudgetApiService] Réponse reçue pour les types de données:', response);
                        
                        // Vérifier si la réponse contient un attribut content (pagination Spring)
                        var responseData = extractContent(response).data;
                        
                        // Normaliser les identifiants en chaînes
                        var normalizedData = responseData.map(function(item) {
                            return {
                                id: normalizeId(item.id),
                                code: item.code || normalizeId(item.id),
                                libelle: item.libelle
                            };
                        });
                        
                        console.log('[BudgetApiService] Types de données normalisés:', normalizedData);
                        cache.typesDonnees[jeuDonneesCode] = normalizedData;
                        return { data: normalizedData };
                    })
                    .catch(function(error) {
                        console.error('[BudgetApiService] Erreur lors de la récupération des types de données pour ' + jeuDonneesCode + ':', error);
                        // Créer des données de secours pour permettre à l'interface de fonctionner
                        var mockData;
                        
                        if (jeuDonneesCode === 'budget-etat') {
                            mockData = [
                                { id: 1, code: 'recettes-fiscales', libelle: 'Recettes fiscales' },
                                { id: 2, code: 'depenses-investissement', libelle: 'Dépenses budgétaires' }
                            ];
                        } else if (jeuDonneesCode === 'tableau-des-operations-financieres-de-letat') {
                            mockData = [
                                { id: 3, code: 'recettes-dons', libelle: 'Recettes et dons' },
                                { id: 4, code: 'depenses', libelle: 'Dépenses' },
                                { id: 5, code: 'financement', libelle: 'Financement' }
                            ];
                        } else {
                            mockData = [
                                { id: 6, code: 'default-type', libelle: 'Type par défaut' }
                            ];
                        }
                        
                        cache.typesDonnees[jeuDonneesCode] = mockData;
                        return { data: mockData };
                    });
            },
            
            // Récupérer les données pour un jeu de données, un type et une année spécifiques
            getDonnees: function(jeuDonneesCode, typeCode, annee) {
                // Normaliser les identifiants
                jeuDonneesCode = normalizeId(jeuDonneesCode);
                typeCode = normalizeId(typeCode);
                annee = normalizeId(annee);
                
                var apiUrl = '/api/budget/donnees/' + jeuDonneesCode + '/' + typeCode + '/' + annee;
                console.log('[BudgetApiService] Requête GET vers', apiUrl);
                
                return $http.get(apiUrl)
                    .then(function(response) {
                        console.log('[BudgetApiService] Réponse reçue pour getDonnees:', response);
                        // Vérifier si la réponse contient un attribut content (pagination Spring)
                        return extractContent(response);
                    })
                    .catch(function(error) {
                        console.error('[BudgetApiService] Erreur lors de la récupération des données brutes:', error);
                        return { data: [] }; // Retourner un tableau vide en cas d'erreur
                    });
            },
            
            // Récupérer les données au format attendu par le frontend (structure hiérarchique)
            getDonneesFormattees: function(jeuDonneesCode, typeCode, annee) {
                // Normaliser les identifiants
                jeuDonneesCode = normalizeId(jeuDonneesCode);
                typeCode = normalizeId(typeCode);
                annee = normalizeId(annee);
                
                var apiUrl = '/api/budget/donnees-formattees/' + jeuDonneesCode + '/' + typeCode + '/' + annee;
                console.log('[BudgetApiService] Requête GET vers', apiUrl);
                
                return $http.get(apiUrl)
                    .then(function(response) {
                        console.log('[BudgetApiService] Réponse reçue pour getDonneesFormattees:', response);
                        
                        // Vérifier si la réponse contient un attribut content (pagination Spring)
                        return extractContent(response);
                    })
                    .catch(function(error) {
                        console.error('[BudgetApiService] Erreur lors de la récupération des données formatées:', error);
                        // Générer des données de démonstration 
                        var mockData = generateMockData(jeuDonneesCode, typeCode, annee);
                        return { data: mockData };
                    });
            },
            
            // Récupérer les données du TOFE
            getTofeData: function(typeCode, annee) {
                console.log('[BudgetApiService] Appel getTofeData pour typeCode:', typeCode, 'annee:', annee);
                
                // On récupère d'abord les jeux de données pour obtenir le code du TOFE
                var self = this;
                
                return this.getJeuxDonnees()
                    .then(function(response) {
                        console.log('[BudgetApiService] Jeux de données récupérés pour getTofeData:', response.data);
                        var jeuxDonnees = response.data;
                        var tofeJeu = jeuxDonnees.find(function(jeu) {
                            return jeu.libelle.toLowerCase().includes('tableau des opérations') ||
                                   jeu.libelle.toLowerCase().includes('operations financieres');
                        });
                        
                        var jeuDonneesCode = tofeJeu ? tofeJeu.code : 'tableau-des-operations-financieres-de-letat';
                        console.log('[BudgetApiService] Jeu de données TOFE trouvé:', jeuDonneesCode);
                        
                        // Si typeCode est vide, utiliser un fallback
                        if (!typeCode) {
                            console.log('[BudgetApiService] typeCode non spécifié, utilisation de \'recettes-dons\' par défaut');
                            typeCode = 'recettes-dons';
                        }
                        
                        return self.getDonneesFormattees(jeuDonneesCode, typeCode, annee);
                    })
                    .catch(function(error) {
                        console.error('[BudgetApiService] Erreur lors de la récupération des données TOFE:', error);
                        // Utiliser le mécanisme de fallback avec des données mockées
                        var mockData = generateMockData('tableau-des-operations-financieres-de-letat', typeCode || 'recettes-dons', annee);
                        return { data: mockData };
                    });
            },
            
            // Récupérer les données du Budget de l'État
            getBudgetEtatData: function(annee) {
                console.log('[BudgetApiService] Appel getBudgetEtatData pour année:', annee);
                
                // On récupère d'abord les jeux de données pour obtenir le code du Budget de l'État
                var self = this;
                
                return this.getJeuxDonnees()
                    .then(function(response) {
                        console.log('[BudgetApiService] Jeux de données récupérés pour getBudgetEtatData:', response.data);
                        var jeuxDonnees = response.data;
                        var budgetJeu = jeuxDonnees.find(function(jeu) {
                            return jeu.libelle.toLowerCase().includes('budget de l\'état') ||
                                   jeu.libelle.toLowerCase().includes('budget de l\'etat');
                        });
                        
                        var jeuDonneesCode = budgetJeu ? budgetJeu.code : 'budget-etat';
                        console.log('[BudgetApiService] Jeu de données Budget trouvé:', jeuDonneesCode);
                        
                        // Par défaut, nous utilisons le type 'recettes-fiscales'
                        var defaultTypeCode = 'recettes-fiscales';
                        
                        // Récupérer les types pour ce jeu de données
                        return self.getTypesDonnees(jeuDonneesCode)
                            .then(function(typesResponse) {
                                console.log('[BudgetApiService] Types de données récupérés pour getBudgetEtatData:', typesResponse.data);
                                var types = typesResponse.data;
                                var recettesType = types.find(function(type) {
                                    return type.libelle.toLowerCase().includes('recettes');
                                });
                                
                                var typeCode = recettesType ? recettesType.code : defaultTypeCode;
                                console.log('[BudgetApiService] Type de données Budget sélectionné:', typeCode);
                                
                                return self.getDonneesFormattees(jeuDonneesCode, typeCode, annee);
                            })
                            .catch(function(error) {
                                console.error('[BudgetApiService] Erreur lors de la récupération des types:', error);
                                // Utiliser directement le type par défaut
                                return self.getDonneesFormattees(jeuDonneesCode, defaultTypeCode, annee);
                            });
                    })
                    .catch(function(error) {
                        console.error('[BudgetApiService] Erreur lors de la récupération des données du Budget:', error);
                        // Utiliser le mécanisme de fallback avec des données mockées
                        var mockData = generateMockData('budget-etat', 'recettes-fiscales', annee);
                        return { data: mockData };
                    });
            },
            
            // Méthode pour récupérer les codes de filtre à partir des jeux de données dynamiques
            getFilterCodes: function() {
                var deferred = $q.defer();
                var self = this;
                
                this.getJeuxDonnees().then(function(response) {
                    var jeuxDonnees = response.data;
                    var budgetJeu = jeuxDonnees.find(function(jeu) {
                        return jeu.libelle.toLowerCase().includes('budget de l\'état') ||
                               jeu.libelle.toLowerCase().includes('budget de l\'etat');
                    });
                    
                    var tofeJeu = jeuxDonnees.find(function(jeu) {
                        return jeu.libelle.toLowerCase().includes('tableau des opérations') ||
                               jeu.libelle.toLowerCase().includes('operations financieres');
                    });
                    
                    var budgetJeuCode = budgetJeu ? budgetJeu.code : 'budget-etat';
                    var tofeJeuCode = tofeJeu ? tofeJeu.code : 'tableau-des-operations-financieres-de-letat';
                    
                    // Récupérer les types pour le Budget de l'État
                    self.getTypesDonnees(budgetJeuCode).then(function(budgetTypes) {
                        // Récupérer les types pour le TOFE
                        self.getTypesDonnees(tofeJeuCode).then(function(tofeTypes) {
                            var budgetTypesData = budgetTypes.data;
                            var tofeTypesData = tofeTypes.data;
                            
                            // Création des constantes dynamiques
                            var constants = {
                                BUDGET_ETAT: budgetJeuCode,
                                TABLEAU_OPERATIONS: tofeJeuCode
                            };
                            
                            // Ajouter les codes de type pour le Budget
                            if (budgetTypesData && budgetTypesData.length > 0) {
                                budgetTypesData.forEach(function(type) {
                                    var upperKey = type.code.replace(/-/g, '_').toUpperCase();
                                    constants[upperKey] = type.code;
                                });
                            } else {
                                // Fallback si aucun type n'est trouvé
                                constants.RECETTES_FISCALES = 'recettes-fiscales';
                                constants.DEPENSES_INVESTISSEMENT = 'depenses-investissement';
                            }
                            
                            // Ajouter les codes de type pour le TOFE
                            if (tofeTypesData && tofeTypesData.length > 0) {
                                tofeTypesData.forEach(function(type) {
                                    var upperKey = type.code.replace(/-/g, '_').toUpperCase();
                                    constants[upperKey] = type.code;
                                });
                            } else {
                                // Fallback si aucun type n'est trouvé
                                constants.RECETTES_DONS = 'recettes-dons';
                                constants.DEPENSES = 'depenses';
                                constants.FINANCEMENT = 'financement';
                            }
                            
                            deferred.resolve(constants);
                        });
                    });
                });
                
                return deferred.promise;
            },
            
            // Récupérer les documents budgétaires liés à un jeu de données
            getDocuments: function(jeuDonneesCode, typeDonneesCode, annee) {
                console.log('[BudgetApiService] Récupération des documents pour:', jeuDonneesCode, typeDonneesCode, annee);
                
                var apiUrl = '/api/budget-documents/by-filters?jeuDonneesCode=' + encodeURIComponent(jeuDonneesCode);
                
                if (typeDonneesCode) {
                    apiUrl += '&typeDonneesCode=' + encodeURIComponent(typeDonneesCode);
                }
                
                if (annee) {
                    apiUrl += '&annee=' + encodeURIComponent(annee);
                }
                
                console.log('[BudgetApiService] Requête GET vers', apiUrl);
                
                return $http.get(apiUrl)
                    .then(function(response) {
                        console.log('[BudgetApiService] Réponse reçue pour getDocuments:', response);
                        return response;
                    })
                    .catch(function(error) {
                        console.error('[BudgetApiService] Erreur lors de la récupération des documents:', error);
                        // Si l'API n'est pas disponible, retourner une liste vide
                        return { data: [] };
                    });
            },
            
            // Helper pour effacer le cache
            clearCache: function() {
                cache.jeuxDonnees = [];
                cache.typesDonnees = {};
            }
        };
    }
})();
